<template>
  <v-container>
    <v-layout>
      <v-flex>
        <v-data-table
          :headers="headers"
          :items="APKList"
          :rows-per-page-items="[20]"
          class="apk-table"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.apk_id }}</td>
            <td>{{ props.item.apk_code }}</td>
            <td>{{ props.item.apk_name }}</td>
            <td>{{ props.item.apk_created | changeDateFormat }}</td>
            <td class="text-xs-right">
              <v-btn icon small @click="removeItem(props.item.apk_name)">
                <v-icon>close</v-icon>
              </v-btn>
            </td>
          </template>
          <template slot="footer">
            <td :colspan="headers.length + 1" class="text-xs-right">
              <v-btn flat @click="routeAPK">+ add</v-btn>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import axios from "axios";
export default {
  name: "apk",
  data: () => ({
    headers: [
      {
        text: "ID",
        align: "left",
        sortable: false,
        value: "id"
      },
      { text: "Code", value: "code", sortable: false },
      { text: "Name", value: "name", sortable: false },
      { text: "Date", value: "date", sortable: false },
      { text: "", value: "delete", sortable: false }
    ],
    APKList: []
  }),
  created() {
    this.init();
  },
  methods: {
    init() {
      axios
        .get(this.$hostname + "/admin/apks", {
          headers: {
            Authorization: localStorage.getItem("token")
          }
        })
        .then(response => {
          console.log(response);
          this.APKList = response.data.data;
        });
    },
    routeAPK() {
      this.$router.push("/add-apk");
    },
    removeItem(item) {
      let formData = new FormData();
      formData.append("apk_name", item);
      formData.forEach((value, key) => {
        console.log("%s: %s", key, value);
      });
      axios
        .post(this.$hostname + "/admin/delete_apk", formData, {
          headers: {
            Authorization: localStorage.getItem("token")
          }
        })
        .then(response => {
          console.log(response);
          this.init();
        });
    }
  },
  filters: {
    changeDateFormat(value) {
      return value.split(" ")[0];
    }
  }
};
</script>
<style lang="scss">
.apk-table {
  .v-datatable {
    thead {
      th {
        font-weight: 700;
        font-size: 16px;
      }
    }
    tbody {
      td {
        font-weight: 700;
        font-size: 16px;
      }
    }
  }
}
</style>
